var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c("div", { staticClass: "container container-medium" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-3 d-none d-lg-block" }, [
          _c("ul", [
            _c("li", { staticClass: "footer-title" }, [
              _c(
                "strong",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "new-account" } } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("footer_new_account_link")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "col-lg-3 d-none d-lg-block" }, [
          _c("ul", [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "how-it-works" } } }, [
                  _vm._v(_vm._s(_vm.$t("header_how_does_it_work"))),
                ]),
              ],
              1
            ),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "questions" } } }, [
                  _vm._v(_vm._s(_vm.$t("faq_title"))),
                ]),
              ],
              1
            ),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "info" } } }, [
                  _vm._v(_vm._s(_vm.$t("info"))),
                ]),
              ],
              1
            ),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "about-us" } } }, [
                  _vm._v(_vm._s(_vm.$t("about_us"))),
                ]),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "col-lg-3 d-none d-lg-block" }, [
          _c("ul", [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "terms" } } }, [
                  _vm._v(_vm._s(_vm.$t("terms"))),
                ]),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "confidentiality" } } },
                  [_vm._v(_vm._s(_vm.$t("new_account_pc")))]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "cookies" } } }, [
                  _vm._v(_vm._s(_vm.$t("cookies"))),
                ]),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("ul", [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "contact" } } }, [
                  _vm._v("Contact"),
                ]),
              ],
              1
            ),
          ]),
          _c("p", { staticClass: "footer-small-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("footer_copyright", { currentYear: _vm.currentYear })
              )
            ),
          ]),
          _vm._m(0),
          _vm._m(1),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "footer-small-text" }, [
      _vm._v("Developed by "),
      _c("a", { attrs: { href: "https://controlf5.ro", target: "_blank" } }, [
        _c("img", {
          staticClass: "ctrlf5",
          attrs: {
            src: require("../media/logo-controlf5.png"),
            alt: "Control F5",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            href: "https://romania.payu.com/",
            target: "_blank",
            rel: "nofollow",
          },
        },
        [
          _c("img", {
            staticClass: "payu",
            attrs: { src: require("../media/payu.png"), alt: "PayU" },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }